import React, { useEffect, useState } from 'react';
import { useBooking } from '../../context/BookingContext';
import { usePlayrooms } from '../../context/PlayroomsContext';
import { Collapse, Button, Steps, Checkbox } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Panel } = Collapse;

export default function SpecialOffersSelection() {

    const { bookingState, updateBooking } = useBooking();
    const { choosenPlayroom } = usePlayrooms();
    const [selectedOffers, setSelectedOffers] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        console.log(choosenPlayroom);
    }, [choosenPlayroom]);

    const handlePackageSelect = (pkgId) => {
        if (selectedOffers.includes(pkgId)) {
            // If the package is already selected, remove it
            setSelectedOffers(selectedOffers.filter(id => id !== pkgId));
        } else {
            // Otherwise, add it to the selected packages
            setSelectedOffers([...selectedOffers, pkgId]);
        }
    };

    const items = choosenPlayroom?.specialOffers?.map((sof, index) => ({
        key: sof.id,
        label: (
            <div className="flex items-center justify-between w-full">
                <div className="flex-grow">
                    <label className="block text-lg text-blue-600 font-semibold mb-2">
                        {sof.name}
                    </label>
                </div>
                <div>
                    <Checkbox
                        className="scale-125" // Makes the checkbox larger
                        checked={selectedOffers.includes(sof.id)} // Check the box if this package is selected
                        onChange={() => handlePackageSelect(sof.id)} // Handle package selection
                    />
                </div>
            </div>
        ),
        children: (
            <div>
                {/* <ul className="list-disc ml-5">
                    {pkg?.offers?.map((offer, offerIndex) => (
                        <li key={offerIndex}>
                            {offer}
                        </li>
                    ))}
                </ul> */}
            </div>
        )
    }));

    const onsubmit = () => {
        updateBooking("specialOffersId", selectedOffers);
        navigate("/reservation-form");
    }

    const onChange = (key) => {
        console.log('Active panel:', key);
    };

    return (
        <div className="flex flex-col items-center justify-start h-screen bg-blue-100">

            <div className="w-full mb-4 px-2 py-4">
                <Steps
                    direction='horizontal'
                    size="small"
                    current={1}
                    items={[
                        {
                            title: <label className="block text-lg font-semibold mb-2">Izaberi paket</label>,
                        },
                        {
                            title: <label className="block text-lg text-blue-600 font-semibold mb-2">Izaberi posebnu ponudu</label>,
                        },
                        {
                            title: <label className="block text-lg  font-semibold mb-2">Popuni podatke</label>,
                        },
                        {
                            title: <label className="block text-lg font-semibold mb-2">Pregled rezervacije</label>,
                        },
                    ]}
                />
            </div>
            <div className="w-full mb-4 px-2 py-4 text-left">

                <Collapse
                    accordion={false}  // Disable accordion mode to allow multiple panels to be open
                    defaultActiveKey={['1']}
                    onChange={onChange}
                    style={{ backgroundColor: '#f0f0f0' }}  // Light gray color for Collapse
                >
                    {items?.map(item => (
                        <Panel header={item.label} key={item.key}>
                            {item.children}
                        </Panel>
                    ))}
                </Collapse>
            </div>

            <div className="flex-1">
                <Button
                    className="w-80 bg-green-500 text-white hover:bg-green-600 focus:ring-0 focus:bg-green-500 active:bg-green-500 text-xl font-semibold py-8"
                    type='submit'
                    // disabled={selectedPackages.length === 0}  // Disable button if no package is selected
                    onClick={onsubmit}  // Log selected packages
                >
                    Rezerviši termin
                </Button>
            </div>
        </div>
    );
}